import React, { useState, useEffect, useContext } from "react";
import { translate } from "utils/Translate";
import { useNavigate, useParams } from "react-router-dom";
import { callAPI } from "utils/API";
import ProductNormal from "components/elements/ProductNormal";
import { setupProductImages } from "utils/productImageHelper";
import CircularIndeterminate from "components/blocks/progressBar/progressBar";
import { Box, useMediaQuery } from "@mui/material";
import ContentNormal from "components/elements/ContentNormal";
import Headline5 from "components/elements/Headline5";
import FileSaver from "file-saver";
import { AppContext } from "contexts/AppContext";
import ButtonMedium4 from "components/elements/ButtonMedium4";

const Wishlist = () => {
  const { brandData } = useContext(AppContext);
  const navigate = useNavigate();
  const { ShopID } = useParams();
  const [loading, setLoading] = useState(true);
  const [pdfExportLoading, setPdfExportLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const isMobile = useMediaQuery('(max-width:900px)')
  const pointSuffix = translate("_POINTS_SHORT_", "pt")

  const productReaction = async (product) => {
    const ReactionID = product.reaction ? product.reaction.ReactionID : null;
    const reaction = await callAPI("/product/reaction", "POST", {
      body: {
        ReactionTargetID: product.ProductID,
        reactionData: JSON.stringify({ ShopID: product.ShopID }),
        ...(ReactionID && { ReactionID }),
      },
    });

    if (reaction && reaction.affectedRows) {
      fetchWishlistProducts();
    }
  }

  const fetchWishlistProducts = async () => {
    const shopproducts = await callAPI(`product/wishlist`, "GET")
    shopproducts.forEach(product => {
      setupProductImages(product, false)
    })
    setLoading(false)
    setProducts(shopproducts)
  }

  const onExportToPdfClick = async () => {
    setPdfExportLoading(true)
    try {
      const pdfBase64 = await callAPI(`product/exportWishlist`, "GET", { query: { showRetailPrice: !!brandData?.features?.exportWishlistShowRetailPrice } })
      const byteCharacters = atob(pdfBase64);
      const byteNumbers = new Array(byteCharacters.length);
  
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
  
      FileSaver.saveAs(blob, `${brandData.brandSlug}_wishlist.pdf`);
    } catch (err) {
      
    }
    setPdfExportLoading(false)
  }

  useEffect(() => {
    fetchWishlistProducts()
  }, [ShopID])

  return (
    <Box flex={1} display={'flex'} flexDirection={'column'} gap={4}>
      {loading
        ?
        <Box marginTop={4} display={'flex'} flex={1} justifyContent={'center'} >
          <CircularIndeterminate />
        </Box>
        :
        products?.length <= 0
          ?
          <Box display={'flex'} flexDirection={'column'} alignItems={'center'} marginTop={4}>
            <Headline5
              translationKey='_NO_PRODUCTS_'
              fallbackText='Ingen produkter'
              style={{textAlign: 'center'}}
            />
            <ContentNormal
              translationKey='_EMPTY_WISHLIST_'
              fallbackText='Du har ingen produkter på ønskelisten'
              style={{textAlign: 'center'}}
            />
          </Box>
          :
          <Box display={'flex'} flexDirection={'column'} gap={3}>
            {!!brandData?.features?.showExportWishlistButton &&
              <Box display={'flex'} justifyContent={'start'}>
                <ButtonMedium4
                  showIcon={false}
                  translationKey={"_EXPORT_TO_PDF_"}
                  fallbackText={"Eksportér til PDF"}
                  onClick={onExportToPdfClick}
                  loading={pdfExportLoading}
                />
              </Box>
            }
            <Box display={'flex'} columnGap={isMobile ? 1 : 6} rowGap={6} flexWrap={'wrap'} justifyContent={isMobile ? 'flex-start' : undefined}>
              {products.map((item) => (
                <ProductNormal
                  productID={item.ProductID}
                  key={item.ProductID}
                  showTag={item.enableDiscount ? true : false}
                  tagOptions={{
                    fallbackText: `${translate("_PRODUCT_DISCOUNT_TAG_TEXT_", "Spar")} ${item.productPointComputed - item.discountPointComputed} ${pointSuffix}`,
                    showClose: false,
                  }}
                  tagStyles={{ borderRadius: 8 }}
                  points={`${item.discountPointComputed ? item.discountPointComputed : item.productPointComputed}`}
                  liked={item.reaction?.ReactionID > 0}
                  className="productlarge"
                  style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px" }}
                  text2={item.elementTitle}
                  text1={item.manufacturer}
                  wishlistCallback={() => productReaction(item)}
                  imageSrc={`url(${item.images[0].imageOriginSource})`}
                  imageBackgroundColor={item.imageBackgroundColor}
                  outOfStock={
                    item.variations?.length &&
                    item.variations[0].limitedStock &&
                    item.variations[0].variationStock <= 0
                  }
                  activityName='profile'
                />
              ))}
            </Box>
          </Box>
      }
      <Box display={'flex'} justifyContent={'center'} >
        <ButtonMedium4
          showIcon={false}
          translationKey="_PROFILE_PAGE_SEE_ALL_PRODUCTS_"
          fallbackText="Se alle produkter"
          onClick={() => navigate(`/shop`)}
        />
      </Box>
    </Box>
  )
}

export default Wishlist;
